// pages/NotFound.js
//
// Anything the router does not recognise. It exists so that a mistyped URL still goes through
// HelmetWrapper: with no catch-all, <Routes> matched nothing, rendered nothing, and the app's
// chrome -- the side bar, with Profile, Change Password and Logout -- was drawn to whoever asked,
// signed in or not.

import React from 'react';
import { Link } from 'react-router-dom';

function NotFound() {
  return (
    <div className="p-8">
      <div className="max-w-xl rounded-lg border border-gray-200 bg-white p-6 shadow-sm">
        <h1 className="text-lg font-bold text-gray-900">Page not found</h1>
        <p className="mt-2 text-sm text-gray-600">
          There is no screen at this address. It may have been renamed, or the link may be out of date.
        </p>
        <Link to="/" className="mt-4 inline-block text-sm font-semibold text-blue-600 underline">
          Go to the dashboard
        </Link>
      </div>
    </div>
  );
}

export default NotFound;
